import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { FormBase } from "commonAssets/components/FormBase";
import { createElement } from "commonAssets/lib/createElement";
import { modal } from "commonAssets/lib/modal";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { validateField } from "commonAssets/lib/validateField";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { loadMember } from "commonAssets/lib/loadMember";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { generateMd5Hash } from "commonAssets/lib/generateMd5Hash";
import { toggleFieldWarning } from "commonAssets/lib/toggleFieldWarning";
import { removeClaimFile } from "commonAssets/lib/removeClaimFile";
import { uploadFile } from "commonAssets/lib/uploadFile";
import { validOTP } from "commonAssets/lib/validOTP";
import { createOTPForm } from "commonAssets/lib/createOTPForm";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import {
    i18n,
    loading,
    outputDiv,
    reCAPTCHAv3,
} from "commonAssets/js/constants";
import { appPayMethod } from "commonAssets/js/constants";
import {
    dstPaymentIframeTitle,
    dstMember,
    dstProcess,
} from "commonAssets/components/FormBase/DigitalDisbursements";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";

let login_claim = false;

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                // Claim Deadline - Default Pacific DateTime
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                datetime = "March 21, 2026 at 11:59:59 P.M.";

                /**
                 * Claim Guard
                 */
                if (form.form_options.notice_confirmation.display === true) {
                    // Guard
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    // const zero_zero_id =
                    //     document.getElementById("zero_zero_id");
                    // const confirmation_code =
                    //     document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    // // Notice Id and Confirmation Code
                    // [zero_zero_id, confirmation_code].forEach(function (input) {
                    //     input.addEventListener("change", validateField);
                    // });

                    // Skip Guard
                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            // Hide guard
                            // document.getElementById('guard').classList.add("d-none");
                            document.getElementById("guard").remove();
                            // New Claim Form
                            container.appendChild(
                                this.claim_form(form, datetime)
                            );
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            // Init claim fields
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });

                        document.getElementById("submit-guard").addEventListener("click", () => {
                            login_claim = true;
                            // Hide guard
                            // document.getElementById('guard').classList.add("d-none");
                            document.getElementById("guard").remove();
                            // New Claim Form
                            container.appendChild(
                                this.claim_form(form, datetime)
                            );
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            // Init claim fields
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );

                            // Prepend Notice ID and Confirmation Code to contact-information section
                            const contactInfoSection = document.getElementById("contact-information");
                            if (contactInfoSection) {
                                const noticeFields = createElement("div", { class: "row mb-3" }, [
                                    createElement("div", { class: "col-md-6" }, [
                                        createElement("label", { for: "notice_id" }, [], "Notice ID *<span class='error'></span>"),
                                        createElement("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "notice_id",
                                            name: "notice_id",
                                            "data-validate": "required",
                                            "data-label": "Notice ID",
                                            required: true
                                        })
                                    ]),
                                    createElement("div", { class: "col-md-6" }, [
                                        createElement("label", { for: "confirmation_code_field" }, [], "Confirmation Code *<span class='error'></span>"),
                                        createElement("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "confirmation_code_field",
                                            name: "confirmation_code_field",
                                            "data-validate": "required",
                                            "data-label": "Confirmation Code",
                                            required: true
                                        })
                                    ])
                                ]);
                                const contactInfoBody = document.getElementById("contactInfoBody");
                                if (contactInfoBody) {
                                    contactInfoBody.insertAdjacentElement('afterend', noticeFields);
                                } else {
                                    contactInfoSection.insertBefore(noticeFields, contactInfoSection.firstChild);
                                }
                            }
                        });
                    }

                    // ada compliance updates - added
                    // if input#submit-guard was clicked add .was-verified to form#guard
                    // document
                    //     .getElementById("submit-guard")
                    //     .addEventListener("click", () => {
                    //         document
                    //             .getElementById("guard")
                    //             .classList.add("was-validated");
                    //         // TODO: add required text to labels
                    //     });

                    // // Validate Guard Fields
                    // document
                    //     .getElementById("guard")
                    //     .addEventListener("submit", (e) => {
                    //         e.preventDefault();

                    //         let valid = true;
                    //         const member = {
                    //             domain: this.claim.data.domain,
                    //             zero_zero_id: zero_zero_id.value.toUpperCase(),
                    //             confirmation_code: confirmation_code.value,
                    //         };

                    //         clearMessage();

                    //         // Validate guard fields
                    //         [zero_zero_id, confirmation_code].forEach(
                    //             function (input) {
                    //                 valid = validateField(input) && valid;
                    //             }
                    //         );
                    //         if (!valid) return;

                    //         loadingGif(loading, "show");

                    //         // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    //         this.claim.api
                    //             .classMemberPost({}, member)
                    //             .then((result) => {
                    //                 // Check for error message
                    //                 if (result.data.error) {
                    //                     toggleFieldError(
                    //                         zero_zero_id,
                    //                         true,
                    //                         ""
                    //                     );
                    //                     toggleFieldError(
                    //                         confirmation_code,
                    //                         true,
                    //                         ""
                    //                     );
                    //                     this.errorHandler.log_exception(
                    //                         new Error(
                    //                             "Error loading class member",
                    //                             { cause: result }
                    //                         )
                    //                     );
                    //                     this.errorHandler.display_modal(result);
                    //                     return;
                    //                 }

                    //                 // Add notice id and confirmation code to claim data
                    //                 this.claim.data.zero_zero_id =
                    //                     member.zero_zero_id;
                    //                 this.claim.data.confirmation_code =
                    //                     member.confirmation_code;

                    //                 // Define the environment for the OTP
                    //                 const environment =
                    //                     this.claim.data.domain.split(".")[0]; // ada compliance - added

                    //                 if (result.data.claim_id) {
                    //                     this.claim.data.claim_id =
                    //                         result.data.claim_id;
                    //                     this.claim.class_member = result.data;
                    //                     if (environment !== "local") {
                    //                         this.send_otp(
                    //                             form,
                    //                             container,
                    //                             result.data,
                    //                             claim_deadline
                    //                         );
                    //                         return;
                    //                     }
                    //                 }

                    //                 // Populate claim form
                    //                 this.populate_claim_form(
                    //                     form,
                    //                     container,
                    //                     result.data,
                    //                     claim_deadline
                    //                 );
                    //             })
                    //             .catch((error) => {
                    //                 this.errorHandler.log_exception(
                    //                     new Error(
                    //                         "Error loading class member",
                    //                         { cause: error }
                    //                     )
                    //                 );
                    //                 this.errorHandler.display_modal(error);
                    //             });
                    //     });
                } else {
                    /**
                     * No Claim Guard
                     */
                    // Edit claim link
                    this.edit_claim(form);

                    // New Claim Form
                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    // Init claim fields
                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }


    guard(params, getDeadline, type) {
        let form;
        if (params.form_options.generic_claim.display) {
            // If the Guard allows Generic Claims
            form = createElement(
                "form",
                {
                    class: "needs-validation",
                    id: "guard",
                    method: "post",
                },
                [
                    createElement(
                        "div",
                        { class: "row fs-5", id: "guardRow" },
                        [
                            this.notice_confirmation(params),
                            this.notice_generic(params),
                        ]
                    ),
                    this.claim_deadline(params, getDeadline, type),
                ]
            );
        } else {
            // For closed classes
            form = createElement(
                "form",
                {
                    class: "needs-validation",
                    id: "guard",
                    method: "post",
                },
                [
                    createElement(
                        "div",
                        { class: "row fs-5", id: "guardRow" },
                        [
                            this.notice_confirmation(
                                params,
                                "col-md-6 offset-md-3 mb-5"
                            ),
                        ]
                    ),
                    this.claim_deadline(params, getDeadline, type),
                ]
            );
        }
        return form;
    }

    notice_confirmation(params, additionalParams) {
        const noticeID = createElement(
            "fieldset",
            {
                class: additionalParams ? additionalParams : "col-md-6 mb-5",
                id: "notice-confirmation",
            },
            [
                createElement(
                    "div",
                    {
                        class: "bg-light text-dark border rounded p-3",
                    },
                    [
                        createElement(
                            "p",
                            { class: "mb-3" },
                            [],
                            params.form_options.notice_confirmation.body
                        ),
                        createElement("div", {}, [
                            createElement("input", {
                                type: "submit",
                                class: "btn btn-primary",
                                id: "submit-guard",
                                value: params.form_options.notice_confirmation
                                    .submit_guard,
                            }),
                        ]),
                    ]
                ),
            ]
        );
        return noticeID;
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input, #claim-fields textarea, #claim-fields select, #notice_id, #confirmation_code_field";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions input, #transactions textarea, #transactions select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    async process_claim(e, claim, deadline) {
        console.log("[process_claim]");

        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess === null
        ) {
            claim = dstProcess(this.claim);
        } else if (
            appPayMethod &&
            appPayMethod !== "" &&
            this.customDstProcess !== null
        ) {
            claim = this.customDstProcess(this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        if (login_claim && document.getElementById('notice_id').value && document.getElementById('confirmation_code_field').value) {
            const member = {
                domain: this.claim.data.domain,
                zero_zero_id: document.getElementById('notice_id').value.toUpperCase(),
                confirmation_code: document.getElementById('confirmation_code_field').value,
            };

            loadingGif(loading, "show");

            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
            await this.claim.api
                .classMemberPost({}, member)
                .then((result) => {
                    console.log(result);
                    // Check for error message
                    if (result.data.error) {
                        claim.flags.valid = false;
                        modal(
                            i18n.getTranslation("error"),
                            'The Notice ID and Confirmation Code you entered do not match our records. Please check your information and try again.'
                        );
                    }
                    loadingGif(loading, "hide", 250);
                }).catch((error) => {
                    this.errorHandler.log_exception(
                        new Error(
                            "Error loading class member",
                            { cause: error }
                        )
                    );
                    this.errorHandler.display_modal(error);
                });
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise
                .execute(reCAPTCHAv3, { action: "submit" })
                .then((token) => {
                    claim.data.token = token;
                    this.post_claim(claim, s3env);
                });
        } else {
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_form_errors")
            );
        }
    }
}
